import React from 'react';
import HomePageHeader from '../HomePageHeader';
import Footer from '../HomePageFooter';
import ImageHeading from './ImageHeading';

const Management = () => {

    const renderManagementSection = () => {
        return (
            <section className='legal pt-5 pb-5'>
                <div className='container'>
                    <div className="row">
                        <div className="pr-heading aim">
                            <h1>
                                Management
                            </h1>
                        </div>
                    </div>
                    <div className='row'>
                        <p>
                            St.Andrew’s College is an institution of Church of North India, Lucknow Diocese.
                            The management is termed as College governing Body and the Board of Directors are termed as Members of College Governing Body as per registration of the College Association.
                            Bishop of Lucknow Diocese is the ex-officio chairman of the College Governing Body and Principal of the College is the ex-officio Secretary of the College Governing Body.
                            Other members of the College Governing body are persons of high repute, leading residents of area and academicians of high excellence, diocesan representatives and a few college staff.
                        </p>
                    </div>
                </div>
            </section>
        );
    }

    return (
        <>
            <HomePageHeader />
            <ImageHeading heading='Management' />
            {renderManagementSection()}
            <Footer />
        </>
    );
}

export default Management;